import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { ConfirmedButton } from "@teamprevent/common/confirmedButton/ConfirmedButton";

import { deleteCustomerCategory } from "../actions";
import { basePathSelector, routeIdSelector } from "../selectors";

export const DeleteButton = () => {
    const dispatch = useDispatch();
    const basePath = useSelector(basePathSelector);
    const id = useSelector(routeIdSelector);
    const deleteCategory = () => dispatch(deleteCustomerCategory(id, basePath));
    return (
        <ConfirmedButton
            icon="delete"
            content="Delete"
            floated="left"
            className="warning"
            onClick={deleteCategory}
            promptText="Are you sure you want to delete this customer category? Type 'DELETE' and click confirm to delete."
            typeToConfirmText="DELETE"
            headingText="Delete Customer Category"
        />
    );
};
